<template>
  <div class="wrapper">
    <div class="material-operation">
      <div class="operation-list">
        <div class="two-font-wrapper" style="margin-right: 1vw">
          <div class="icon-font">&#xe73d;</div>
          导入
          <input readonly="readonly" style="position: absolute;left: 0;top: 0;width: 100%;height: 100%;opacity: 0" type="file" value="" id="file" @change="uploadConfig">
        </div>
        <div class="four-font-wrapper" @click="download" style="margin-right: 1vw"><div class="icon-font">&#xe621;</div>下载模板</div>
        <div class="four-font-wrapper" @click="deleteAll"><div class="icon-font">&#xe646;</div>批量删除</div>
      </div>
      <div class="operation-list">
        <div class="input-wrapper" style="margin-right: 1vw">
          <input v-model="keyword" placeholder="请输入关键字"/>
        </div>
        <div class="query button" @click="handleSearch(1)">查询</div>
      </div>
    </div>
    <div class="detail">
      <div class="detail-box">
        <div class="loading-data" v-if="loading">
          <i class="el-icon-loading"></i>
          <div>加载中，请稍后···</div>
        </div>
        <div class="detail-nav">
          <div class="detail-item" style="width: 10%">
            <div class="select-icon" :class="{'select-icon-active': all}" @click="selectAll"></div>
          </div>
          <div class="detail-item" style="width: 10%">物料编号</div>
          <div class="detail-item" style="width: 30%">烟叶简称</div>
          <div class="detail-item" style="width: 15%">产地</div>
          <div class="detail-item" style="width: 10%">类型</div>
          <div class="detail-item" style="width: 10%">制单人</div>
          <div class="detail-item" style="width: 15%">操作</div>
        </div>
        <div class="detail-content">
          <div class="detail-list-wrapper" v-if="!loading && tableData.length>0" v-for="(data,index) in tableData" :key="index">
            <div class="detail-item" style="width: 10%" >
              <div class="select-icon" :class="{'select-icon-active': data.sign === 1}" @click="selectSingle(data.id)"></div>
            </div>
            <div class="detail-item" style="width: 10%">
              <el-popover
                placement="top"
                title=""
                trigger="hover"
                :content="data.code">
                <div class="popover" style="width: 8vw" slot="reference">{{data.code}}</div>
              </el-popover>
            </div>
            <div class="detail-item" style="width: 30%">{{data.name}}</div>
            <div class="detail-item" style="width: 15%">{{data.placeOfOrigin}}</div>
            <div class="detail-item" style="width: 10%">{{data.type}}</div>
            <div class="detail-item" style="width: 10%">{{data.createdUser}}</div>
            <div class="detail-item" style="width: 15%">
              <div class="detail-btn item-look" style="margin-right: 0.5vw" @click="toMaterialDetail(data.id)">查看</div>
              <div class="detail-btn item-delete" @click="deleteSingle(data.id)">删除</div>
            </div>
          </div>
          <div class="none-data" v-if="!loading && tableData.length<1">暂无数据</div>
        </div>
        <div class="page-wrapper" v-if="!loading && total > rows">
          <div class="page-wrapper-left">共{{total}}条数据，每页显示{{rows}}条，当前第{{page}}页</div>
          <div class="page-wrapper-right">
            <div class="page-btn" @click="firstPage">首页</div>
            <div class="page-btn" @click="previousPage">上一页</div>
            <div class="page-btn" @click="nextPage">下一页</div>
            <div class="page-btn" @click="lastPage">尾页</div>
          </div>
        </div>
      </div>
      <transition name="fade">
        <div class="alert-box" v-if="show">
          <div class="alert-content">
            <div class="alert-content-title">删除提醒</div>
            <div class="alert-content-msg">是否确认删除选中数据?</div>
            <div class="alert-content-btn">
              <div class="btn-cancel button" @click="cancelDelete">取消</div>
              <div class="btn-confirm button" @click="confirmDelete">确认</div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div class="remind-box" v-if="showAlert">
          <div class="remind-content">
            <div class="remind-content-title">提醒</div>
            <div class="remind-content-msg">
              <div class="remind-content-msg-item" v-for="(data, index) in alertData" :key="index">{{data}}</div>
            </div>
            <div class="remind-content-btn">
              <div class="btn-confirm button" @click="confirmAlert">确认</div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <img class="wrapper-icon" src="../../../assets/content-box.png"/>
  </div>
</template>

<script>
import {batchImport, materialPage, delMaterial, bathDelMaterial} from '../../../api/basic'
export default {
  name: 'Material',
  data () {
    return {
      alertData: [],
      showAlert: false,
      show: false,
      all: false,
      id: '',
      type: 0,
      idList: [],
      loading: false,
      keyword: '',
      page: 1,
      rows: 10,
      total: '',
      tableData: []
    }
  },
  created () {
    this.handleSearch(1)
  },
  methods: {
    confirmAlert: function () {
      this.showAlert = false
    },
    download: function () {
      // let xhr = new XMLHttpRequest()
      // const downloadUrl = '/api/basic/material/materialDownload'
      // xhr.open('GET', downloadUrl, true)
      // xhr.addEventListener('progress', function (event) {
      //   // 响应头要有Content-Length
      //   if (event.lengthComputable) {
      //     let percentComplete = event.loaded / event.total
      //     console.log(percentComplete) // 最后输出1
      //   }
      // }, false)
      // xhr.send()
      location.href = '/api/basic/material/materialDownload'
      // location.href = '/api/maintain/qualityTesting/qualityTestingDownload'
    },
    uploadConfig: function (e) {
      let formData = new FormData()
      formData.append('file', e.target.files[0])
      console.log(formData)
      if (e.target.files[0].name.lastIndexOf('.xls') > 0 || e.target.files[0].name.lastIndexOf('.XLS') > 0) {
        batchImport(formData).then(res => {
          console.log(res)
          if (res.code === 711) {
            this.alertData = res.message.split('&')
            this.alertData.splice(this.alertData.length - 1, 1)
            this.showAlert = true
            e.target.value = ''
          } else {
            this.$message({
              message: '导入成功!',
              type: 'success',
              center: 'true',
              duration: '1000'
            })
            this.handleSearch(1)
            e.target.value = ''
          }
        }).catch(err => {
          console.log(err)
          e.target.value = ''
        })
      } else {
        this.$message({
          message: '文件格式不正确!',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      }
    },
    selectAll: function () {
      this.type = 1
      this.all = !this.all
      let idList = []
      if (this.all) {
        this.tableData.map((data) => {
          data.sign = 1
          idList.push(data.id)
        })
        this.idList = idList
      } else {
        this.tableData.map((data) => {
          data.sign = 0
          this.idList = []
        })
      }
    },
    selectSingle: function (id) {
      this.tableData.map((data) => {
        if (id === data.id) {
          data.sign = data.sign === 1 ? 0 : 1
          if (data.sign === 1) {
            this.idList.push(data.id)
          } else {
            let idList = []
            this.idList.map((item) => {
              if (item !== id) {
                idList.push(item)
              }
            })
            this.idList = idList
          }
          console.log(this.idList)
        }
      })
      this.all = this.idList.length === this.tableData.length
    },
    deleteSingle: function (id) {
      this.show = true
      this.id = id
      this.type = 0
    },
    deleteAll: function () {
      if (this.idList.length !== 0) {
        this.show = true
        this.type = 1
      } else {
        this.$message({
          message: '请选择要删除的数据!',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      }
      console.log(this.idList)
    },
    cancelDelete: function () {
      this.show = false
    },
    confirmDelete: function () {
      if (this.type === 0) {
        console.log(this.id)
        let body = {
          pkId: this.id
        }
        delMaterial(body).then(res => {
          console.log(res)
          this.$message({
            message: '删除成功!',
            type: 'success',
            center: 'true',
            duration: '1000'
          })
          this.show = false
          this.handleSearch()
        }).catch(err => {
          console.log(err)
        })
      } else {
        console.log(this.idList)
        let body = {
          pkIdLs: this.idList.join()
        }
        bathDelMaterial(body).then(res => {
          console.log(res)
          this.$message({
            message: '删除成功!',
            type: 'success',
            center: 'true',
            duration: '1000'
          })
          this.show = false
          this.handleSearch()
        }).catch(err => {
          console.log(err)
        })
      }
    },
    toMaterialDetail: function (id) {
      this.$router.push({
        path: '/materialDetail',
        query: {
          index: '4',
          pkId: id
        }
      })
    },
    handleSearch: function (click) {
      if (click === 1) {
        this.page = 1
      }
      this.loading = true
      let body = {
        keyword: this.keyword,
        page: this.page,
        rows: this.rows
      }
      materialPage(body).then(res => {
        console.log(res)
        res.data.rows && res.data.rows.map(item => {
          item.sign = 0
        })
        this.tableData = res.data.rows || []
        this.total = res.data.total
        this.loading = false
        this.all = false
        this.idList = []
      }).catch(err => {
        console.log(err)
      })
    },
    firstPage: function () {
      console.log('首页')
      if (this.page === 1) {
        this.$message({
          message: '当前为第一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        this.page = 1
        this.handleSearch()
      }
    },
    previousPage: function () {
      console.log('上一页')
      if (this.page < 2) {
        this.$message({
          message: '当前为第一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        this.page--
        this.handleSearch()
      }
    },
    nextPage: function () {
      console.log('下一页')
      if (parseInt(this.total / this.rows) + 1 > this.page) {
        this.page++
        this.handleSearch()
      } else {
        this.$message({
          message: '当前为最后一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      }
    },
    lastPage: function () {
      console.log('尾页')
      if (this.page === parseInt(this.total / this.rows) + 1) {
        this.$message({
          message: '当前为最后一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        if (Math.round(this.total % this.rows) === 0) {
          this.page = parseInt(this.total / this.rows)
        } else {
          this.page = parseInt(this.total / this.rows) + 1
        }
        this.handleSearch()
      }
    }
  }
}
</script>

<style scoped>
@import "./Material.css";
</style>



// WEBPACK FOOTER //
// src/page/basic/material/Material.vue